/** Every query param of the respondent's survey link, sent on session start so a panel's extra
 *  ids (Ario's `player`) are stored with the session. The backend bounds what it keeps. */
export const collectUrlParams = (searchParams: URLSearchParams): Record<string, string> => {
  const params: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    const trimmed = value.trim();
    if (trimmed && !(key in params)) params[key] = trimmed;
  });
  return params;
};
